import { Component, OnInit } from '@angular/core';
import { AuthServiceService } from '../services/auth-service.service';
import { RouterModule } from '@angular/router';
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { showCustomeAlert } from '../services/Alert/alert.service';
import { LoaderComponent } from '../Common/loader/loader.component';

@Component({
  selector: 'app-profile',
  imports: [CommonModule,ReactiveFormsModule,RouterModule,LoaderComponent],
  templateUrl: './profile.component.html',
  styleUrl: './profile.component.scss'
})
export class ProfileComponent implements OnInit{
  isLoading : boolean = false;
  constructor(private _authService : AuthServiceService){ }
  User : any;
  UserID : any;
  registerForm = new FormGroup({
    firstName: new FormControl("", [Validators.required]),
    lastName: new FormControl("", [Validators.required]),
    userName: new FormControl("", [Validators.required]),
    email: new FormControl("", [Validators.required, Validators.email]),
  });
  changePasswordForm = new FormGroup({
    currentPassword : new FormControl("",[Validators.required]),
    newPassword : new FormControl("",[Validators.required]),
    confirmPassword : new FormControl("",[Validators.required])
  })
  ngOnInit(): void {
    this.isLoading = true;
    const userSession = this._authService.getUserSession();
    this.UserID = userSession.tokenValue.unique_name;
      this._authService.getUserById(userSession.tokenValue.unique_name).subscribe((res:any)=>{
        if(res.result){
          this.User = res.result;
          this.registerForm.patchValue({
            firstName : res.result.firstName,
            lastName : res.result.lastName,
            userName : res.result.userName,
            email : res.result.email,
          })
          this.isLoading = false;
        }
      })
  }

  onUpdateSubmit(){ 
    const isMailchanged = this.registerForm.value.email !== this.User.email || this.registerForm.value.userName !== this.User.userName; 
    const isNameChanged = this.registerForm.value.firstName !== this.User.firstName || this.registerForm.value.lastName !== this.User.lastName; 
    if(this.registerForm.valid && isMailchanged || isNameChanged){
        this._authService.updateUserDetails(this.registerForm.value,this.UserID).subscribe((res:any)=>{
          if(res.result){
            showCustomeAlert("success","The changes you've done are complately applied","Update Confirmed..!!");
            this.ngOnInit()
          }
        },(err:any)=>{
          showCustomeAlert("error","Something went wrong..","Error");
        })
    }else{
      showCustomeAlert("warning","Please fill all the details.","Alert..!");
    }
  }
  onPasswordChangeSubmit(){
    if(this.changePasswordForm.valid){
      this._authService.changePassword(this.changePasswordForm.value,this.UserID).subscribe((res:any)=>{
        if(res.result){
          showCustomeAlert("success","Password has been chaged.","Paassword Changed..!!");
          this.ngOnInit()
        }
      },(err:any)=>{
        showCustomeAlert("error","Something went wrong..","Error");
      })
  }else{
    showCustomeAlert("warning","Please fill all the details.","Alert..!");
  }
  }
}
